import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { DevoteeService } from '../devotee.service';
import { Serialkey, SerialKeyResponse } from './serialkey';

@Component({
  selector: 'app-serialkey',
  templateUrl: './serialkey.component.html',
  styleUrls: ['./serialkey.component.css']
})
export class SerialkeyComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private devoteeService: DevoteeService) { }

  serialKeyForm: FormGroup;
  stateList: string[] = [];
  savedMessage: string = "";
  errorMessage: string = "";
  serialKey: SerialKeyResponse;

  ngOnInit() {
    this.createAddSerialKeyForm();
  }

  saveForm(): void {
    if (this.serialKeyForm.invalid) {
      this.sharedService.validateAllFormFields(this.serialKeyForm);
      console.log(this.serialKeyForm.errors);
      return;
    }

    this.sharedService.showSpinner();
    this.devoteeService.GetLicenseKey(this.serialKeyForm.value).subscribe(
      data => {
        this.serialKey = data;
        this.serialKey.IsSuccess = data.IsSuccess;
        this.sharedService.hideSpinner()
      },
      err => {
        this.errorMessage = err.error.Message;
        console.log(this.errorMessage);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  createAddSerialKeyForm(): void {
    this.serialKeyForm = this.formBuilder.group({
      Id: [0],
      CustomerName: [, Validators.required],
      SerialKey: [, Validators.required],
      ActiveDays: [, Validators.required],
      RequestedBy: [, Validators.required],
      Password: [, Validators.required]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/serialkey/serialkey.component.ts